import moment from 'moment';

// Air+ timestamps are database wall-clock values serialized in ISO form. Their
// trailing timezone marker must not shift the calendar day in the browser.
export const getStoredStudyDate = (timestamp) => {
  if (!timestamp) return null;

  const storedDate = String(timestamp).match(/^(\d{4}-\d{2}-\d{2})(?:[T\s]|$)/)?.[1];
  if (storedDate) return storedDate;

  const parsed = moment(timestamp);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
};

// A streak stays alive for the rest of the current day. For example, when the
// learner studied yesterday but has not studied yet today, yesterday's streak
// is still displayed. It resets only after an entire calendar day is missed.
export const calculateStudyStreak = (timestamps = [], referenceDate = moment()) => {
  const today = moment(referenceDate).startOf('day');
  if (!today.isValid()) return 0;

  const studiedDates = new Set(
    timestamps
      .map(getStoredStudyDate)
      .filter(Boolean)
      .filter((date) => !moment(date, 'YYYY-MM-DD', true).isAfter(today, 'day')),
  );

  let cursor = today.clone();
  const todayKey = cursor.format('YYYY-MM-DD');

  if (!studiedDates.has(todayKey)) {
    cursor.subtract(1, 'day');
  }

  let streak = 0;
  while (studiedDates.has(cursor.format('YYYY-MM-DD'))) {
    streak += 1;
    cursor.subtract(1, 'day');
  }

  return streak;
};
